/**
 * Stable CSS class names for E2E — Schedule detail page.
 */
export const SD = {
    page: 'schedule-detail-page',
    breadcrumbRow: 'schedule-detail-page__breadcrumb-row',

    layout: 'schedule-detail-page__layout',
    leftCol: 'schedule-detail-page__left-col',
    rightCol: 'schedule-detail-page__right-col',

    historyCard: 'schedule-detail-page__history-card',
    historyTitle: 'schedule-detail-page__history-title',

    historyActions: 'schedule-detail-page__history-actions',
    refreshButton: 'schedule-detail-page-input--button-refresh-history',
    refreshIcon: 'schedule-detail-page__refresh-icon',

    gridWrap: 'schedule-detail-page__grid-wrap',

    cellHistoryIdWrap: 'schedule-detail-page__cell-history-id-wrap',
    cellHistoryIdTooltip: 'schedule-detail-page__cell-history-id-tooltip',
    cellHistoryIdText: 'schedule-detail-page__cell-history-id-text',

    cellStartTime: 'schedule-detail-page__cell-start-time',
    cellEndTime: 'schedule-detail-page__cell-end-time',
    cellWorkTime: 'schedule-detail-page__cell-work-time',
    cellErrorMessage: 'schedule-detail-page__cell-error-message',

    cellSuccessTooltip: 'schedule-detail-page__cell-success-tooltip',
    cellSuccessIconWrap: 'schedule-detail-page__cell-success-icon-wrap',
    cellSuccessIconSuccess: 'schedule-detail-page__cell-success-icon--success',
    cellSuccessIconError: 'schedule-detail-page__cell-success-icon--error',

    cellSeeResponseButton: 'schedule-detail-page-input--button-see-response',
} as const;

export const sdCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

